// import {useAnalytics} from 'use-analytics';
// import useGaTracker from '@hooks/useGaTracker';
import GlobalError from '@components/pages/GlobalError';
import {LiveFoundObject, TLatLng} from '@context/MapContext';
import {ProjectContext} from '@context/ProjectContext';
import {CssBaseline, PaletteMode} from '@mui/material';
import {green, orange, red} from '@mui/material/colors';
import {createTheme, Direction, ThemeProvider} from '@mui/material/styles';
import socket from '@sockets';
import {useEffect, useState} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {useTranslation} from 'react-i18next';
import {QueryClient, QueryClientProvider} from 'react-query';
// @ts-ignore
// import googleAnalytics from '@analytics/google-analytics';
import {Outlet, useLocation} from 'react-router-dom';
// import Analytics from 'analytics';
// @ts-ignore
// import googleAnalytics from '@analytics/google-analytics';
// @ts-ignore
// import googleAnalyticsV3Plugin from '@analytics/google-analytics-v3'
// import {AnalyticsProvider} from 'use-analytics';
import RTL from './RTL';

const queryClient = new QueryClient();
export default function App() {
	useEffect(() => {
		socket.connect();
	}, []);
	const location = useLocation();
	const [themeMode, setThemeMode] = useState<PaletteMode>(localStorage.getItem('theme') as PaletteMode ?? 'light');
	const defaultFontSize = Number(localStorage.getItem('font_size') ?? 14);
	const [fontSize, setFontSize] = useState<number>(isNaN(defaultFontSize) ? 14 : defaultFontSize);
	const [liveLocation, setLiveLocation] = useState<TLatLng | null>(null);
	const [liveFound, setLiveFound] = useState(LiveFoundObject.NotFound);
	const shahadat = true;
	// const analytics = useAnalytics();
	const {t} = useTranslation();
	// const
	const theme = createTheme({
		direction: t('_dir') as Direction,
		components: {
			MuiSkeleton: {
				defaultProps: {
					animation: 'wave'
				}
			},
			// MuiButton: {
			// 	styleOverrides: {
			// 		root: { minHeight: 0 }
			// 	}
			// },
			MuiTab: {
				styleOverrides: {
					root: {minHeight: 0}
				}
			}
		},
		palette: {
			mode: themeMode,
			primary: {
				main: themeMode === 'light' ? '#0755e4' : '#b5c4ff',
				A200: '#fefbff',
				A100: '#f6f9ff',
				50: '#eff0ff',
				100: '#dbe1ff',
				200: '#b5c4ff',
				300: '#8da8ff',
				400: '#638aff',
				500: '#336cfa',
				600: '#0051de',
				700: '#003dab',
				800: '#00297a',
				900: '#00174c'
			},
			secondary: {
				main: '#539fe5',
				A200: '#fcfcff',
				A100: '#f4faff',
				50: '#e9f1ffff',
				100: '#d0e4ff',
				200: '#9bcbff',
				300: '#66b0f7',
				400: '#4895db',
				500: '#257bbf',
				600: '#00629f',
				700: '#004a79',
				800: '#003256',
				900: '#001d34'
			},
			grey: {
				A200: '#fff',
				A100: '#f9f9f9',
				50: '#f3f3f3',
				100: '#e4e4e4',
				200: '#c9c9c9',
				300: '#acaaaf',
				400: '#959595',
				500: '#767676',
				600: '#636363',
				700: '#494949',
				800: '#353535',
				900: '#1f1f1f',
				A700: '#191b23',
				A400: '#2e3038'
			},
			success: {
				...green
			},
			warning: {
				...orange
			},
			error: {
				main: '#ba1a1a',
				A200: '#fffbff',
				A100: '#fff5f5',
				50: '#ffedea',
				100: '#ffdad6',
				200: '#ffb4ab',
				300: '#ff897d',
				400: '#ff5449',
				500: '#de3730',
				600: '#ba1a1a',
				700: '#93000a',
				800: '#690005',
				900: '#410002'
			},
			background: {
				default: themeMode === 'light' ? '#fff' : '#1b1b1f',
				paper: themeMode === 'light' ? '#fff' : '#23232a'
			}
		},
		typography: {
			fontSize,
			fontFamily: `${t('_font')}`
		}
	});
	
	// useGaTracker();
	// Custom inline analytics plugin
	// const myPlugins = {
	// 	name: 'rezvan-plugins',
	// 	page: ({payload}: any) => {
	// 		console.log('page view fired', payload);
	// 	},
	// 	track: ({payload}: any) => {
	// 		console.log('track event payload', payload);
	// 	}
	// };
	//
	// const analyticsPLugins = Analytics({
	// 	app: 'rezvan',
	// 	plugins: [
	// 		myPlugins,
	// 		googleAnalytics({
	// 			measurementIds: appConfig.analytics.googleV4
	// 		}),
	// 		// /* Load Google Analytics v3 */
	// 		googleAnalyticsV3Plugin({
	// 			trackingId: appConfig.analytics.googleV3,
	// 		}),
	// 	]
	// });
	// useGaTracker();
	//toDO disable analytics
	/*useEffect(() => {
	 analytics.page();
	 }, [location]);*/
	
	return (
		// <AnalyticsProvider instance={analyticsPLugins}>
		<ErrorBoundary FallbackComponent={GlobalError}>
			<QueryClientProvider client={queryClient}>
				<ProjectContext.Provider
					value={{
						theme: themeMode,
						setTheme: setThemeMode,
						setFontSize,
						liveLocation,
						setLiveLocation,
						liveFound,
						setLiveFound,
						shahadat
					}}>
					<ThemeProvider theme={theme}>
						<RTL direction={theme.direction}>
							<CssBaseline/>
							<Outlet/>
						</RTL>
					</ThemeProvider>
				</ProjectContext.Provider>
			</QueryClientProvider>
			{/*</AnalyticsProvider>*/}
		</ErrorBoundary>
	);
}
